import '@/exposeVendorCore'; // Expose Bootstrap JS globally

import { createApp } from 'vue';
import { createPinia } from 'pinia';

import config from '@/App/config';
import resourcePlugin from '@/App/VueCore/plugins/resourcePlugin';
import fileSizePlugin from '@/App/VueCore/plugins/fileSizePlugin';
import directivesPlugin from '@/App/VueCore/plugins/directivesPlugin';
import AppealDetailsEntry from '@/App/Views/AppealDetailsEntry/AppealDetailsEntry.vue';
import { useContextDataStore } from '@/App/VueCore/stores/contextDataStore';

// Attach bootstrap to the window to enable it globally and provide access to the bootstrap API from any place
import * as bootstrap from 'bootstrap'; (window as any).bootstrap = bootstrap;

// Initialize Vue app instead of Knockout bindings
initializeVueApp();

function initializeVueApp(): void {
  // Initialize Vue app and mount to the element
  const vueBoundElement = document.getElementById('vueBoundElement');
  const clientMessages = JSON.parse(vueBoundElement?.getAttribute('data-client-messages') ?? '{}');
  const appealPublicReference = vueBoundElement?.getAttribute('data-appeal-public-reference') ?? '';

  const app = createApp(AppealDetailsEntry, { clientMessages, appealPublicReference });
  const pinia = createPinia();
  app.use(pinia);

  const contextDataStore = useContextDataStore();
  // Use the language code defined by the lang attribute on the html tag
  let languageCode: string = document.getElementsByTagName('html')[0].getAttribute('lang')?.toLowerCase() ?? '';
  const languageCodeSupported = config.supportedLanguageCodes.indexOf(languageCode) > -1;
  languageCode = languageCodeSupported ? languageCode : config.defaultLanguageCode;
  contextDataStore.languageCode = languageCode;
  app.use(resourcePlugin);
  app.use(fileSizePlugin);
  app.use(directivesPlugin);
  app.mount('#vueBoundElement');
}
